export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";